import { render } from "./registrationForm.vue?vue&type=template&id=74bdd61e&scoped=true"
import script from "./registrationForm.vue?vue&type=script&lang=js"
export * from "./registrationForm.vue?vue&type=script&lang=js"

import "./registrationForm.vue?vue&type=style&index=0&id=74bdd61e&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bdd61e"]])

export default __exports__